import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// InstallModal kaldırıldı
import { formatCurrency, getCurrencySymbol } from '../utils/currency';
import { TrendingUp, Flame, FileText, Bell, Newspaper, Calendar, BarChart3, Search, LogOut, User, Home, Wallet, CreditCard, Upload, MessageCircle, Key, RefreshCw, Settings, Hash, DollarSign } from 'lucide-react';

// Runtime detection
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) ? 'http://localhost:8001/api' : '/api';

// Helper function to get full URL for assets
const getFullAssetUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${url}`;
};

function Navbar({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  // PWA install kaldırıldı
  // showInstallModal kaldırıldı
  const [homepageBroker, setHomepageBroker] = useState(null);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [audioElement, setAudioElement] = useState(null);
  
  // Fetch homepage broker on mount
  useEffect(() => {
    const fetchHomepageBroker = async () => {
      try {
        const response = await fetch(`${API}/homepage-broker`);
        const data = await response.json();
        if (data) {
          console.log('🏦 Navbar: Homepage broker loaded:', data.name);
          setHomepageBroker(data);
        }
      } catch (err) {
        console.error('Failed to fetch homepage broker:', err);
      }
    };
    fetchHomepageBroker();
  }, []);
  
  // Fallback: Update user balance via API (WebSocket is primary - in App.js)
  useEffect(() => {
    if (user) {
      const fetchBalance = async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${API}/auth/me`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          const data = await response.json();
          setUser(data);
        } catch (err) {
          console.error('Failed to fetch user balance:', err);
        }
      };
      // Fallback: Refresh balance every 30 seconds (WebSocket handles real-time)
      const interval = setInterval(fetchBalance, 30000);
      return () => clearInterval(interval);
    }
  }, [user?.id]);

  // Initialize notification sound
  useEffect(() => {
    const notificationSound = "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBTGH0fPTgjMGHm7A7+OZSA0PVKzn77BdGAg+ltzy0H4pBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBQ==";
    const audio = new Audio(notificationSound);
    setAudioElement(audio);
  }, []);

  // Real-time notification polling
  useEffect(() => {
    if (!user) return;

    const fetchUnreadCount = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`${API}/notifications/unread/count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        const newCount = data.count || 0;

        // Play sound if count increased
        if (newCount > unreadNotifications && unreadNotifications > 0 && audioElement) {
          audioElement.play().catch(e => console.log('Audio play failed:', e));
        }

        setUnreadNotifications(newCount);
      } catch (err) {
        console.error('Failed to fetch notification count:', err);
      }
    };

    // Initial fetch
    fetchUnreadCount();

    // Poll every 15 seconds (performans için artırıldı)
    const interval = setInterval(fetchUnreadCount, 15000);

    return () => clearInterval(interval);
  }, [user, audioElement, unreadNotifications]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };

  const menuItems = [
    { path: '/trading', icon: TrendingUp, label: 'İşlem Yap' },
    { path: '/positions', icon: FileText, label: 'Pozisyonlar' },
  ];

  const userMenuItems = [
    { 
      action: () => navigate('/notifications'), 
      icon: Bell, 
      label: 'Bildirimler',
      badge: unreadNotifications > 0 ? unreadNotifications : null
    },
    { action: () => navigate('/deposit'), icon: Wallet, label: 'Para Yatır' },
    { action: () => navigate('/withdraw'), icon: CreditCard, label: 'Para Çek' },
    { action: () => navigate('/profile'), icon: User, label: 'Profil' },
    { action: () => navigate('/documents'), icon: Upload, label: 'Belge Yükle' },
    { action: () => navigate('/change-password'), icon: Key, label: 'Şifre Değiştir' },
    // Removed: Sayfayı Yenile - causes unwanted page reloads
    { action: handleLogout, icon: LogOut, label: 'Çıkış Yap', className: 'text-red-400' },
  ];

  if (user?.is_admin) {
    userMenuItems.splice(-1, 0, {
      action: () => navigate('/admin'),
      icon: Settings,
      label: 'Yönetim Paneli',
      className: 'text-blue-500'
    });
  }

  const toggleTheme = () => {
    const root = document.documentElement;
    const currentTheme = root.getAttribute('data-theme');
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <nav className="bg-gray-800 border-b border-gray-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-2">
            {homepageBroker && homepageBroker.logo_url ? (
              <button 
                onClick={() => navigate('/dashboard')}
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
              >
                <div className="bg-white rounded-lg p-1.5 shadow-md flex items-center justify-center">
                  <img 
                    src={getFullAssetUrl(homepageBroker.logo_url)}
                    alt={homepageBroker.name}
                    className="h-10 sm:h-11 w-auto object-contain max-w-[120px]"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallback = e.target.nextElementSibling;
                      if (fallback) fallback.style.display = 'block';
                    }}
                  />
                  <div 
                    className="hidden text-sm font-bold px-2"
                    style={{ color: homepageBroker.color }}
                  >
                    {homepageBroker.name}
                  </div>
                </div>
                <div className="hidden md:block text-left">
                  <div className="text-sm font-bold text-white">{homepageBroker.name}</div>
                  <span className="text-xs text-gray-400">Alım Satım Platformu</span>
                </div>
              </button>
            ) : (
              <button 
                onClick={() => navigate('/dashboard')}
                className="hover:opacity-80 transition-opacity"
              >
                <h1 className="text-xl font-bold text-white">Alım Satım Platformu</h1>
              </button>
            )}
          </div>

          {/* Desktop Menu - REMOVED */}
          <div className="flex-1"></div>

          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center gap-2 sm:gap-3 bg-gray-700 px-2 sm:px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            >
              <div className="text-right text-xs sm:text-sm">
                <div className="text-gray-400 flex items-center gap-1 justify-end">
                  <Hash size={12} />
                  <span>{user?.id}</span>
                </div>
                <div className="font-bold text-green-400 flex items-center gap-1 justify-end">
                  <span>{formatCurrency(user?.displayed_balance ?? user?.balance, user)}</span>
                </div>
              </div>
              
              {/* Bildirim Badge - ID/Para Yanında */}
              {unreadNotifications > 0 && (
                <div className="relative">
                  <Bell size={20} className="text-yellow-400 animate-bounce" />
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 border-gray-800 shadow-lg">
                    {unreadNotifications > 9 ? '9+' : unreadNotifications}
                  </div>
                </div>
              )}
              
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden border-2 border-blue-500">
                {user?.profile_image ? (
                  <img src={user.profile_image} alt="Profile" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold">
                    {user?.email?.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>
            </button>

            {showUserMenu && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setShowUserMenu(false)}
                />
                <div className="absolute right-0 mt-2 w-64 bg-gray-800 rounded-lg shadow-xl border border-gray-700 z-50 overflow-hidden">
                  {/* Balance Display for Mobile */}
                  <div className="sm:hidden bg-gray-750 px-4 py-3 border-b border-gray-700">
                    <div className="text-sm text-gray-400">Ana Kasa (K/Z Dahil)</div>
                    <div className="text-lg font-bold text-green-400">{formatCurrency(user?.displayed_balance ?? user?.balance, user)}</div>
                  </div>
                  
                  {userMenuItems.map((item, idx) => {
                    const MenuIcon = item.icon;
                    return (
                    <button
                      key={idx}
                      onClick={() => {
                        item.action();
                        setShowUserMenu(false);
                      }}
                      className={`w-full px-4 py-3 text-left hover:bg-gray-700 transition-colors flex items-center gap-3 relative ${
                        item.className || 'text-white'
                      }`}
                    >
                      <MenuIcon size={18} />
                      <span>{item.label}</span>
                      {item.badge && (
                        <span className="ml-auto bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold">
                          {item.badge}
                        </span>
                      )}
                    </button>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

    </nav>
  );
}

export default Navbar;
